import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type GetWorkflowRuleDefinitionByIdQueryVariables = GraphQLTypes.Exact<{
  workflowRuleDefinitionId: GraphQLTypes.Scalars['String']['input'];
}>;

export type GetWorkflowRuleDefinitionByIdQueryResult = { __typename?: 'Query' } & {
  workflowRuleDefinitionById: { __typename?: 'WorkflowRuleDefinitionType' } & Pick<
    GraphQLTypes.WorkflowRuleDefinitionType,
    'id' | 'ruleDefinitionTag' | 'ruleDescription' | 'ruleName'
  > & {
      defaultInput?: GraphQLTypes.Maybe<
        { __typename?: 'RuleInputObjectType' } & Pick<
          GraphQLTypes.RuleInputObjectType,
          | 'collectionCountry'
          | 'countryOfDestination'
          | 'countryOfOrigin'
          | 'deliveryCountry'
          | 'destination'
          | 'incoterms'
          | 'modeOfTransport'
          | 'origin'
          | 'portOfDestination'
          | 'portOfDestinationCountry'
          | 'portOfOrigin'
          | 'portOfOriginCountry'
          | 'shipmentContext'
          | 'shipmentType'
        > & {
            account?: GraphQLTypes.Maybe<{ __typename?: 'Account' } & Pick<GraphQLTypes.Account, 'id'>>;
            event?: GraphQLTypes.Maybe<
              Array<GraphQLTypes.Maybe<{ __typename?: 'UserDefinedEventType' } & Pick<GraphQLTypes.UserDefinedEventType, 'id'>>>
            >;
            supplier?: GraphQLTypes.Maybe<{ __typename?: 'Account' } & Pick<GraphQLTypes.Account, 'id'>>;
          }
      >;
      defaultOutput?: GraphQLTypes.Maybe<
        { __typename?: 'RuleOutputObjectType' } & {
          actions?: GraphQLTypes.Maybe<
            Array<{ __typename?: 'WorkflowAction' } & Pick<GraphQLTypes.WorkflowAction, 'label' | 'path' | 'type'>>
          >;
          consignee?: GraphQLTypes.Maybe<{ __typename?: 'AccountLocation' } & Pick<GraphQLTypes.AccountLocation, 'id'>>;
          consignor?: GraphQLTypes.Maybe<{ __typename?: 'AccountLocation' } & Pick<GraphQLTypes.AccountLocation, 'id'>>;
          customerOperationsCoordinator?: GraphQLTypes.Maybe<
            { __typename?: 'AccountMember' } & Pick<GraphQLTypes.AccountMember, 'id'>
          >;
          customsOperationsCoordinator?: GraphQLTypes.Maybe<
            { __typename?: 'AccountMember' } & Pick<GraphQLTypes.AccountMember, 'id'>
          >;
          destinationOperationsCoordinator?: GraphQLTypes.Maybe<
            { __typename?: 'AccountMember' } & Pick<GraphQLTypes.AccountMember, 'id'>
          >;
          notifyParties?: GraphQLTypes.Maybe<
            Array<{ __typename?: 'AccountLocation' } & Pick<GraphQLTypes.AccountLocation, 'id'>>
          >;
          originAgent?: GraphQLTypes.Maybe<{ __typename?: 'Account' } & Pick<GraphQLTypes.Account, 'id'>>;
          originOperationsCoordinator?: GraphQLTypes.Maybe<
            { __typename?: 'AccountMember' } & Pick<GraphQLTypes.AccountMember, 'id'>
          >;
          supplierContacts?: GraphQLTypes.Maybe<Array<{ __typename?: 'AccountMember' } & Pick<GraphQLTypes.AccountMember, 'id'>>>;
        }
      >;
      ruleInputFields: Array<
        { __typename?: 'WorkflowRuleFieldType' } & Pick<
          GraphQLTypes.WorkflowRuleFieldType,
          'component' | 'hidden' | 'label' | 'name' | 'required'
        >
      >;
      ruleOutputFields: Array<
        { __typename?: 'WorkflowRuleFieldType' } & Pick<
          GraphQLTypes.WorkflowRuleFieldType,
          'component' | 'hidden' | 'label' | 'name' | 'required'
        >
      >;
    };
};

export const GetWorkflowRuleDefinitionByIdDocument = gql`
  query getWorkflowRuleDefinitionById($workflowRuleDefinitionId: String!) {
    workflowRuleDefinitionById(workflowRuleDefinitionId: $workflowRuleDefinitionId) {
      defaultInput {
        account {
          id
        }
        collectionCountry
        countryOfDestination
        countryOfOrigin
        deliveryCountry
        destination
        event {
          id
        }
        incoterms
        modeOfTransport
        origin
        portOfDestination
        portOfDestinationCountry
        portOfOrigin
        portOfOriginCountry
        shipmentContext
        shipmentType
        supplier {
          id
        }
      }
      defaultOutput {
        actions {
          label
          path
          type
        }
        consignee {
          id
        }
        consignor {
          id
        }
        customerOperationsCoordinator {
          id
        }
        customsOperationsCoordinator {
          id
        }
        destinationOperationsCoordinator {
          id
        }
        notifyParties {
          id
        }
        originAgent {
          id
        }
        originOperationsCoordinator {
          id
        }
        supplierContacts {
          id
        }
      }
      id
      ruleDefinitionTag
      ruleDescription
      ruleInputFields {
        component
        hidden
        label
        name
        required
      }
      ruleName
      ruleOutputFields {
        component
        hidden
        label
        name
        required
      }
    }
  }
`;
